import { COUNTRY_ID, COUNTRY_SWEDEN_ID, COUNTRY_UAE_ID, URL_SWEDEN_PREFIX, URL_UAE_PREFIX } from "@/data/constants"

class EditorRoute {
  static Home() {
    return '/editor'
  }
  static EditorialContentList() {
    return `${EditorRoute.Home()}/editorial-content`
  }
  static EditorialContentVideoList() {
    return `${EditorRoute.Home()}/editorial-content-video`
  }

  static EditorialContentEdit(item) {
    return `${EditorRoute.Home()}/editorial-content/${item.id}`
  }

  static EditorialContentCreate() {
    return `${EditorRoute.Home()}/editorial-content/create`
  }

  static EditorialContentVideoEdit(item) {
    return `${EditorRoute.Home()}/editorial-content-video/${item.id}`
  }

  static EditorialContentVideoCreate() {
    return `${EditorRoute.Home()}/editorial-content-video/create`
  }

  static CRMContactList() {
    return `${EditorRoute.Home()}/crm/contacts`
  }

  static CRMEmailList() {
    return `${EditorRoute.Home()}/crm/emails`
  }

  static CRMEmailEdit(item) {
    return `${EditorRoute.Home()}/crm/emails/${item.id}`
  }

  static CRMEmailCreate() {
    return `${EditorRoute.Home()}/crm/emails/create`
  }

  static VisualizeImageList() {
    return `${EditorRoute.Home()}/visualize/images`
  }

  static VisualizeImageEdit(item) {
    return `${EditorRoute.Home()}/visualize/images/${item.id}`
  }

  static VisualizeImageCreate() {
    return `${EditorRoute.Home()}/visualize/images/create`
  }

  static VisualizeVideoList() {
    return `${EditorRoute.Home()}/visualize/videos`
  }

  static VisualizeVideoEdit(item) {
    return `${EditorRoute.Home()}/visualize/videos/${item.id}`
  }

  static VisualizeVideoCreate() {
    return `${EditorRoute.Home()}/visualize/videos/create`
  }

  static CoreUserList() {
    return `${EditorRoute.Home()}/core/users`
  }

  static CoreUserDetail(item) {
    return `${EditorRoute.Home()}/core/users/${item.id}`
  }

  static MarketInstrumentList() {
    return `${EditorRoute.Home()}/market/instruments`
  }

  static MarketInstrumentDetail(item) {
    return `${EditorRoute.Home()}/market/instruments/${item.id}`
  }

  static PortfoliosPortfolioList() {
    return `${EditorRoute.Home()}/portfolios/portfolios`
  }

  static PortfoliosPortfolioDetail(item) {
    return `${EditorRoute.Home()}/portfolios/portfolios/${item.id}`
  }

  static CacheList() {
    return `${EditorRoute.Home()}/cache`
  }
}

class Route {
  static getCountrySlugFromId(countryId) {
    if (countryId == COUNTRY_SWEDEN_ID) {
      return URL_SWEDEN_PREFIX
    }
    return URL_UAE_PREFIX
  }

  static LandingPage(countryId = COUNTRY_ID) {
    if (countryId == COUNTRY_SWEDEN_ID) {
      return `/`
    } else if (countryId == COUNTRY_UAE_ID) {
      return `/`
    }
  }

  static MeFollowing() {
    return '/me/following'
  }

  static SearchPage(countryId = COUNTRY_ID) {
    if (countryId == COUNTRY_SWEDEN_ID) {
      return `/${URL_SWEDEN_PREFIX}/search`
    } else if (countryId == COUNTRY_UAE_ID) {
      return `/${URL_UAE_PREFIX}/search`
    }
  }

  static EditorialContentList(countryId = COUNTRY_ID) {
    if (countryId == COUNTRY_SWEDEN_ID) {
      return `/${URL_SWEDEN_PREFIX}/artiklar`
    } else if (countryId == COUNTRY_UAE_ID) {
      return `/${URL_UAE_PREFIX}/insights`
    }
  }

  static EditorialContentListFilter() {
    return `${this.EditorialContentList(COUNTRY_ID)}/f/`
  }

  static UAEPortfolioList() {
    return `/${URL_UAE_PREFIX}/portfolios`
  }

  static MarketList() {
    return `/${URL_UAE_PREFIX}/instruments/markets`
  }

  static MarketDetail(marketSlug) {
    return `/${URL_UAE_PREFIX}/instruments/markets/${marketSlug}`
  }

  static UAEMarketADX() {
    return `/${URL_UAE_PREFIX}/instruments/markets/adx`
  }

  static UAEMarketDFM() {
    return `/${URL_UAE_PREFIX}/instruments/markets/dfm`
  }

  static UAEMarketNasdaqDubai() {
    return `/${URL_UAE_PREFIX}/instruments/markets/nasdaq-dxb`
  }

  static instrumentList(countryId = COUNTRY_ID) {
    if (countryId == COUNTRY_SWEDEN_ID) {
      return `/${URL_SWEDEN_PREFIX}/aktier`
    } else if (countryId == COUNTRY_UAE_ID) {
      return `/${URL_UAE_PREFIX}/instruments`
    }
  }

  static instrumentListFilter(countryId = COUNTRY_ID) {
    return `${this.instrumentList(countryId)}/f/`
  }

  static marketDetail(marketSlug) {
    return `/${URL_UAE_PREFIX}/instruments/markets/${marketSlug}`
  }

  static instrumentDetail(instrument) {
    const countryId = instrument?.country_id
    if (countryId == COUNTRY_SWEDEN_ID) {
      return `/${URL_SWEDEN_PREFIX}/aktier/${instrument?.slug}`
    } else {
      return `/${URL_UAE_PREFIX}/instruments/${instrument?.slug}`
    }
  }

  static instrumentDetailInsightList(instrument) {
    let suffix = 'insights'
    if (instrument.country_id == COUNTRY_SWEDEN_ID) {
      suffix = 'artiklar'
    }
    return `${this.instrumentDetail(instrument)}/${suffix}`
  }

  static InstrumentDetailInsightListFilter(instrument) {
    return `${this.instrumentDetailInsightList(instrument)}/f/`
  }

  static instrumentDetailDisclosureList(instrument) {
    let suffix = 'disclosures'
    if (instrument?.country_id == COUNTRY_SWEDEN_ID) {
      suffix = 'nyheter'
    }
    const href = this.instrumentDetail(instrument)
    return `${href}/${suffix}`
  }

  static InstrumentDetailDisclosureListFilter(instrument) {
    return `${this.instrumentDetailDisclosureList(instrument)}/f/`
  }

  static sectorEditorialContentList(sectorSlug, countryId) {
    if (countryId == COUNTRY_SWEDEN_ID) {
      return `/${URL_SWEDEN_PREFIX}/artiklar/sektor/${sectorSlug}`
    } else if (countryId == COUNTRY_UAE_ID) {
      return `/${URL_UAE_PREFIX}/insights/sector/${sectorSlug}`
    }
  }

  static portfolioDetail(portfolio) {
    return `/${URL_UAE_PREFIX}/portfolios/${portfolio.identifier}/${portfolio.username}`
  }

  static portfolioDetailTransactions(portfolio) {
    return `${this.portfolioDetail(portfolio)}/transactions`
  }

  static portfolioDetailPositions(portfolio) {
    return `${this.portfolioDetail(portfolio)}/positions`
  }

  static threadsAll() {
    return `/${URL_UAE_PREFIX}/threads`
  }

  static threadsOnStocks() {
    return `/${URL_UAE_PREFIX}/threads/stocks`
  }

  static threadsOnPortfolios() {
    return `/${URL_UAE_PREFIX}/threads/portfolios`
  }

  static threadsOnDisclosures() {
    return `/${URL_UAE_PREFIX}/threads/disclosures`
  }

  static threadsOnTransactions() {
    return `/${URL_UAE_PREFIX}/threads/transactions`
  }

  static insightDetail(item) {
    if (item.instrument_identifier) {
      const root = this.instrumentDetailInsightList({
        country_id: item.country_id,
        ticker: item.instrument_ticker,
        pk: item.instrument_identifier,
        slug: item.instrument_slug
      })
      return `${root}/${item.slug}`
    }
    let country = this.getCountrySlugFromId(item.country_id)
    if (item.country_id == COUNTRY_SWEDEN_ID) {
      return `/${country}/artiklar/${item.slug}`
    } else if (item.country_id == COUNTRY_UAE_ID) {
      return `/${country}/insights/${item.slug}`
    }
    return `/${country}/insights/${item.slug}`
  }

  static login(redirect) {
    if (redirect) {
      return `/authentication/login?next=${redirect}`
    }
    return `/authentication/login`
  }
  static loginRedirect(countryId) {
    return `/`
    // if (countryId == COUNTRY_SWEDEN_ID) {
    //   return `/${URL_SWEDEN_PREFIX}`
    // } else if (countryId == COUNTRY_UAE_ID) {
    //   return `/${URL_UAE_PREFIX}`
    // }
    // return `/${URL_UAE_PREFIX}`
  }

  static logout() {
    return `/authentication/logout`
  }

  static signup() {
    return `/authentication/create`
  }

  // DEPRECATED
  static SVPersonDetail(person) {
    return `/${URL_SWEDEN_PREFIX}/people/${person.first_name}${person.last_name}/${person.pk}/`
  }

}

export { Route, EditorRoute }